module.exports = __webpack_public_path__ + "img/Patent_1.1b570b04.jpg";